export default __webpack_public_path__ + "static/media/grafema_ummi_04.44cc4b6c.jpg";